import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EInvoiceValidationControl } from '@core';
import { ACLService } from '@delon/acl';

@Component({
  selector: 'app-einvoice-validation-control-select',
  templateUrl: './einvoice-validation-control-select.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceValidationControlSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceValidationControlSelectComponent implements ControlValueAccessor, OnChanges {

  statusLabel: { [key: number]: string } = {
    [EInvoiceValidationControl.FollowSettings]: "Follow e-Invoice Settings",
    [EInvoiceValidationControl.FullCompliance]: "Full Validation",
    [EInvoiceValidationControl.DeferredCompliance]: "Deferred Validation",
    [EInvoiceValidationControl.NonCompliance]: "Non-Validation"
  }

  @Input() value: number = 0;
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() aclKey: string = '';
  @Input() allowEdit = true;
  @Input() isSupp = false;

  canUpdate: boolean = false;
  options: { value: number; label: string }[] = [];
  
  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    if (item) return item.label;
    return '';
  }

  onChange: any = () => { };
  onTouched: any = () => { };
  constructor(private cdr: ChangeDetectorRef, private acl: ACLService) { }

  ngOnInit() {
    this.generateOptions();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['aclKey']) {
      if (this.aclKey) {
        this.canUpdate = this.acl.can(`${this.aclKey}.update`);
      }
    }
  }

  writeValue(value: number): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }

  private generateOptions() {
    this.options = Object.keys(EInvoiceValidationControl)
      .filter(key => typeof EInvoiceValidationControl[key as keyof typeof EInvoiceValidationControl] === 'number')
      .map(key => ({
        value: EInvoiceValidationControl[key as keyof typeof EInvoiceValidationControl],
        label: this.statusLabel[EInvoiceValidationControl[key as keyof typeof EInvoiceValidationControl]]
      }))
      // Remove if isSupp is true
      .filter(option => !(this.isSupp && option.value === EInvoiceValidationControl.NonCompliance));
    this.cdr.markForCheck();
  }
}
